// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"327603c6","485":"8e797445"}[chunkId] + ".chunk.js";
};